var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.can_view_side_bar)?_c('dashboard-app'):_c('guest-app')],1)}
var staticRenderFns = []

export { render, staticRenderFns }